/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

import { ContentContext } from "context/contentContext";


/**
 * styled components
 */

const Header = styled.header`
  ${t.mixins.flex()}
`;
const NewBanner = styled.span`
  padding: 5px 3px 5px 6px; 
  ${t.mixins.rem(9, 9)}
  font-family: ${t.font.primary};
  font-weight: ${t.font.bold};
  text-transform: uppercase;
  letter-spacing: 3px;
  color: ${t.color.white};
  background-color: ${t.color.primary};
`;
const Filler = styled.div`
  height: 19px;
`;
const Image = styled.img`
  width: 185px;
  height: 145px;
  margin-bottom: 17px;
  ${t.mixins.fit({ size: "contain" })}

  ${({ centered }) =>
    centered &&
    `
      width: 150px;
      height: 115px;
      margin: 0 25px 17px 25px;

      ${t.mixins.sm(`
        width: 117px;
        height: 91px;
        margin: 0 8px 17px 8px;
      `)}
    `}
`;
const Wrapper = styled.div`
  padding-left: 13px;

  ${({ centered }) =>
    centered &&
    `
    ${t.mixins.flex({ direction: "column" })}
    padding-left: 0;
  `}
`;
const Range = styled.p`
  ${t.mixins.rem(24, 24)}
  font-family: ${t.font.secondary};
  font-weight: ${t.font.regular};
  color: ${t.color.darkGrey};

  ${t.mixins.sm(`
    ${t.mixins.rem(22, 24)}
  `)}
`;
const Skus = styled.p`
  margin-bottom: 17px;
  ${t.mixins.rem(16, 16)}
  font-family: ${t.font.secondary};
  font-weight: ${t.font.bold};
  color: ${t.color.primary};

  ${t.mixins.sm(`
    ${t.mixins.rem(13, 16)}
  `)}
`;

/**
 * product component is..
 */

const Content__product = ({ novelty, img, range, skus, centered }) => {
  const { c } = useContext(ContentContext);
  return (
    <>
      <Header>{novelty ? <NewBanner>{c("home.products.new")}</NewBanner> : <Filler />}</Header>
      <Image src={t.image[img] || t.image.no_robot} centered={centered} />
      <Wrapper centered={centered}>
        <Range>{range}</Range>
        <Skus>{skus}</Skus>
      </Wrapper>
    </>
  );
};

export default Content__product;

Content__product.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Content__product.defaultProps = {
  style: {},
  centered: false,
};

/*
    import Content__product from 'components/content/product/content__product'
    <Content__product />
  */
